import template from './employee_category_add.html';
import tr from '../../lib/default-translator.js';

class EmployeeCategoryAddVM
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.categories = ko.observableArray();
		this.main_categories = ko.observableArray();
		this.selected_category = ko.observable();
		this.edit_mode = ko.observable(false);
	};

	edit_category(data)
	{
		this.edit_mode(true);
		data.editing(true);
	};

	async delete_category(v, e)
	{
		let data = ko.mapping.toJS(v);

		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete this category entry ?.')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/admin/employee_field_category/delete', data);
			
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully deleted employee field category.'), title: tr('Success', 'Success')});

				if (this.edit_mode() == true)
						this.edit_mode(false);

				this.dialog.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
		}
	};

	async save_category(v, e)
	{
		let data = ko.mapping.toJS(v);
		
		if (data.employee_field_category_id == '')
			data.employee_field_category_id = null;

		if (isNaN(Number(data.sort_order)) == true)
		{
			Grape.alerts.alert({type: 'error', message: tr('Sorry! The order must be a number'), title: 'Invalid Data'});
			return;
		}

		const category_name = await this.dialog.getSubCategoryNameBySubCategoryId(data.employee_field_sub_category_id);
		if ( category_name == 'Educational')
		{
			let response = await Grape.alerts.confirm({message: tr('Please note that all educational fields will require the Skills and Competency feature role to be displayed.Are you sure you want to continue'), type: 'warning', title: tr('Warning')});
			if (response)
			{
				let res = await Grape.fetches.postJSON('/admin/save_employee_category', data);
	
				if (res.status == 'OK')
				{
					Grape.alerts.alert({type: 'success',message: tr('Successfully saved category.'), title: tr('Success', 'Success')});
					this.edit_mode(false);
					this.dialog.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else if (res.error)
					Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error', 'Error')});
				else
					Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});

				this.edit_mode(false);
			} else
				return;
		}
		else
		{
			let res = await Grape.fetches.postJSON('/admin/save_employee_category', data);
			
			if (res.status == 'OK')
			{
				Grape.alerts.alert({type: 'success', message: tr('Successfully saved category.'), title: tr('Success', 'Success')});
				this.edit_mode(false);
				this.dialog.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else if (res.error)
				Grape.alerts.alert({type: 'error', message: res.error, title: tr('Error', 'Error')});
			else
				Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});

			this.edit_mode(false);
		}
	};

	async close()
	{
		this.dialog.close(true);
	}
};

class EmployeeCategoryAddPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new EmployeeCategoryAddVM(this);
		this.name = 'EmployeeCategoryAddPage';

		let Categories = function(config)
		{
			let data;
			data = $.extend({
				employee_field_category_id: null,
				category: '',
				employee_field_sub_category_id: null,
				employee_field_sub_category_name: '',
				sort_order: null,
				editing: false
			}, config);

			ko.mapping.fromJS(data, {}, this);
		};

		this.add_category = (v, e) => {
			this.viewModel.categories.unshift(new Categories({editing: true}));
			this.viewModel.edit_mode(true);
		};
	};

	async init()
	{
		this.updateData();
	};

	async updateData()
	{
		try {
			let option = {
				table: 'v_employee_field_category',
				schema: 'savanna',
				limit: 1000000
			};

			let res = await Grape.fetches.getJSON('/api/record', option)
			if (res.status == 'OK')
			{
				let data = res.records.map(cat => ({
					...cat,
					editing: ko.observable(false)
				}));

				this.viewModel.categories(data);
			}
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
		}

		try {
			let option = {
				table: 'employee_field_sub_category',
				limit: 1000000
			};

			let res = await Grape.fetches.getJSON('/api/record', option);
			if (res.status == 'OK')
				this.viewModel.main_categories(res.records);
		} catch (error) {
			console.error(error);
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
		}
	};

	async getSubCategoryNameBySubCategoryId(employee_field_sub_category_id)
	{
		let category = ko.utils.arrayFirst(this.viewModel.main_categories(),(item) => {
			return item.employee_field_sub_category_id === employee_field_sub_category_id;
		});

		if (category)
			return category.employee_field_sub_category_name;

		return null; // Return null if no matching category is found
	};
};

export default {
	name: 'EmployeeCategoryAddPage',
	dialog_class: EmployeeCategoryAddPage,
	template: template,
	template_filename: 'translation/dialogs/employee_category_add',
	provider: 'ps'
};
